import { staticLabels } from './staticLabels';
import I18n from 'I18n';
export function getLabel(key) {
  return staticLabels[key] || I18n.text(`developer-docs-source.labels.${key}`);
}